export var SavedAssetSecuritiesChoice;
(function (SavedAssetSecuritiesChoice) {
    SavedAssetSecuritiesChoice["SAVED_ASSET_SECURITIES_ONLY"] = "saved_asset_securities_only";
    SavedAssetSecuritiesChoice["REPORT_SECURITIES_ONLY"] = "report_securities_only";
    SavedAssetSecuritiesChoice["PRIMARY_SECURITY_ONLY"] = "primary_security_only";
    SavedAssetSecuritiesChoice["ADD_PRIMARY_SECURITY"] = "add_primary_security";
    SavedAssetSecuritiesChoice["ADD_REPORT_SECURITIES"] = "add_report_securities";
    SavedAssetSecuritiesChoice["ADD_REPORT_SECURITY_HOLDINGS"] = "add_report_security_holdings";
})(SavedAssetSecuritiesChoice || (SavedAssetSecuritiesChoice = {}));
export var SavedScatterPlotHoldingsChoice;
(function (SavedScatterPlotHoldingsChoice) {
    SavedScatterPlotHoldingsChoice["REPORT_SECURITIES_HOLDINGS_ONLY"] = "report_securities_holdings_only";
    SavedScatterPlotHoldingsChoice["PRIMARY_SECURITY_HOLDINGS_ONLY"] = "primary_security_holdings_only";
    SavedScatterPlotHoldingsChoice["ADD_PRIMARY_SECURITY_HOLDINGS"] = "add_primary_security_holdings";
    SavedScatterPlotHoldingsChoice["ADD_REPORT_SECURITIES_HOLDINGS"] = "add_report_securities_holdings";
})(SavedScatterPlotHoldingsChoice || (SavedScatterPlotHoldingsChoice = {}));
